import * as ascii from "@/utils/encoding/ascii";
import * as base16 from "@/utils/encoding/base16";

/**
 * Converts a base64 encoded string into an ascii string
 */
export const decodeUtf8 = (encoded: string) => {
  const decoded = process.server ? Buffer.from(encoded, "base64").toString() : atob(encoded);

  return ascii.decode(decoded);
};

/**
 * Converts an ascii string into a base64 encoded string
 */
export const encodeUtf8 = (decoded: string) => {
  const escaped = ascii.encode(decoded);

  return process.server ? Buffer.from(escaped, "ascii").toString("base64") : btoa(escaped);
};

/**
 * Converts a base64 encoded string into a hex string
 */
export const decodeHex = (encoded: string) => {
  if (process.server) {
    return Buffer.from(encoded, "base64").toString("hex");
  }

  try {
    const decoded = atob(encoded.replace(/[^a-zA-Z0-9=+/].*/, ""));

    return base16.encodeAscii(decoded);
  } catch (error) {
    return "";
  }
};

/**
 * Converts a hex representation string into a base64 encoded string
 */
export const encodeHex = (decoded: string) =>
  process.server ? Buffer.from(decoded, "hex").toString("base64") : btoa(base16.decodeAscii(decoded));
